import Vue from "vue";
import Vuex from "vuex";
import { Navbar } from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Navbar,
  },
});
